import React from 'react';
import './InfoSection.css';
import { IslandInfo } from '../types';

interface InfoSectionProps {
  islandInfo: IslandInfo;
}

const InfoSection: React.FC<InfoSectionProps> = ({ islandInfo }) => {
  return (
    <div className="trip-card">
      <h2>Where are we located?</h2>
      <p className="info-description">{islandInfo.description}</p>
      
      <div className="trip-card-facts">
        <h3>Getting here</h3>
        <ul>
        <li>
            Our camps are best suited to guests who are comfortable getting to the islands independently
            and exploring at their own pace. We’ll set you up with a great base — the rest is all about
            enjoying the adventure safely.
          </li>
          <li>
            The Abrolhos are remote and spectacular, but they can be a little precarious at times — the
            surrounding reefs are extensive and conditions can change quickly.
          </li>
          <li>
            Weather is a big part of island life. Please plan conservatively and allow flexibility for
            delays if the forecast turns.
          </li>
          
        </ul>
      </div>
    </div>
  );
};
          
export default InfoSection;



